import { Route, Routes } from 'react-router-dom'
import About from '../pages/About'
import Achievements from '../pages/Achievements'
import Contact from '../pages/Contact'
import Home from '../pages/Home'
import Leadership from '../pages/Leadership'
import Products from '../pages/Products'
import Services from '../pages/Services'

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/products" element={<Products />} />
      <Route path="/services" element={<Services />} />
      <Route path="/leadership" element={<Leadership />} />
      <Route path="/achievements" element={<Achievements />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
  )
}

export default AppRoutes
